import type { SVGProps } from "react";

const IconPencil = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6445 3.22918L9.53047 2.11511C8.92311 1.51057 7.94487 1.50001 7.32555 2.09189L0.275878 8.87694C0.0999355 9.04725 0 9.28161 0 9.52793V11.8208C0 12.1903 0.299103 12.4894 0.668582 12.4894H2.97343C3.20779 12.4894 3.43088 12.4014 3.6012 12.2374L10.6213 5.47562C11.2547 4.86545 11.2667 3.85131 10.6445 3.22918ZM2.94387 11.5041H0.99091V9.56312L5.86452 4.86545L7.81186 6.81278L2.93824 11.5048H2.94387V11.5041ZM9.94077 4.76551L8.52126 6.13223L6.57393 4.1849L8.00469 2.80692C8.23342 2.58382 8.6029 2.59016 8.83162 2.81255L9.94569 3.92662C10.18 4.16097 10.1744 4.53679 9.94006 4.76551H9.94077ZM2.33441 3.61625H2.52232C2.52232 2.94204 3.06774 2.39028 3.74828 2.39028V2.20238C3.42596 2.20238 3.10926 2.07359 2.88053 1.84486C2.65181 1.61614 2.52302 1.30507 2.52302 0.977112H2.33511C2.33511 1.29944 2.20632 1.61614 1.9776 1.84486C1.74887 2.07359 1.4378 2.20238 1.10985 2.20238V2.39028C1.78406 2.39028 2.33582 2.93571 2.33582 3.61625H2.33441ZM10.7381 10.4661C10.4038 10.1318 10.2223 9.68628 10.2223 9.21686H9.95273C9.95273 9.68628 9.76482 10.1374 9.43687 10.4661C9.10257 10.8003 8.65709 10.9819 8.18767 10.9819V11.2515C9.16732 11.2515 9.95906 12.0432 9.95906 13.0229H10.2286C10.2286 12.0432 11.0204 11.2515 12 11.2515V10.9819C11.5306 10.9819 11.0795 10.794 10.7508 10.4661H10.7388H10.7381Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconPencil;
